import { supportsOfflinePos, type FrontofficeRuntime } from '../../../runtime/frontofficeRuntime';

/** Electron-only offline login banner; never shown in the browser FO. */
export function shouldShowOfflineLoginBanner(opts: {
  isOnline: boolean;
  runtime?: FrontofficeRuntime;
}): boolean {
  return supportsOfflinePos(opts.runtime) && !opts.isOnline;
}

/**
 * Browser FO is online-only: always allow submitting login (API errors surface normally).
 * Electron FO: allow when online or when a remembered offline profile exists.
 */
export function isLoginFormEnabled(opts: {
  canLoginOffline: boolean;
  firstLaunchBlocked: boolean;
  runtime?: FrontofficeRuntime;
}): boolean {
  if (!supportsOfflinePos(opts.runtime)) {
    return true;
  }
  return opts.canLoginOffline && !opts.firstLaunchBlocked;
}
